import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'state'
})
export class StatePipe implements PipeTransform {

  transform(value: any): string {

    let state = '';
    switch (value) {
      case 'idleState': {
        state = 'ESPERANDO';
        break;
      }
      case 'IDDLE': {
        state = 'ESPERANDO';
        break;
      }
      case 'readingPlateState': {
        state = 'LEYENDO';
        break;
      }
      case 'READING': {
        state = 'LEYENDO';
        break;
      }
      case 'WEIGHING':   {
        state = 'PESANDO';
        break;
      }
      case 'PRINT':   {
        state = 'IMPRIMIENDO';
        break;
      }
      case 'noPlateState': {
        state = 'NO MATRÍCULA';
        break;
      }
      case 'authorizingState': {
        state = 'VALIDANDO';
        break;
      }
      case 'PROCESSING' : {
        state = 'VALIDANDO';
        break;
      }
      case 'deniedState': {
        state = 'DENEGADO';
        break;
      }
      case 'openingState': {
        state = 'ABRIENDO';
        break;
      }
      case 'CROSSING': {
        state = 'PASANDO';
        break;
      }
      case 'crossingState': {
        state = 'PASANDO';
        break;
      }
    }
    return state;
  }

}
